import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'

import { cn } from '@/lib/utils'

function Tabs({ className, ...props }) {
    return <TabsPrimitive.Root data-slot="tabs" className={cn('tw:flex tw:flex-col tw:gap-0', className)} {...props} />
}

function TabsList({ className, ...props }) {
    return (
        <TabsPrimitive.List
            data-slot="tabs-list"
            className={cn(
                'tw:text-muted-foreground tw:inline-flex tw:h-9 tw:w-fit tw:items-center tw:justify-center tw:rounded-lg tw:p-[3px] tw:gap-1.5',
                className,
            )}
            {...props}
        />
    )
}

function TabsTrigger({ className, ...props }) {
    return (
        <TabsPrimitive.Trigger
            data-slot="tabs-trigger"
            className={cn(
                'tw:border-b-[2px] tw:border-transparent tw:dark:hover:border-white tw:hover:border-b-red-500 tw:dark:hover:data-[state=active]:border-blue-300',
                'tw:dark:data-[state=active]:text-foreground tw:focus-visible:border-ring tw:focus-visible:ring-ring/50',
                'tw:focus-visible:outline-ring tw:data-[state=active]:border-blue-300 tw:px-14',
                'tw:dark:text-foreground tw:text-[#2A3749] tw:inline-flex tw:h-[calc(100%-1px)] tw:flex-1 tw:items-center',
                'tw:justify-center tw:gap-1.5 tw:!rounded-t-xs tw:px-6 tw:py-1 tw:text-sm tw:font-medium',
                'tw:whitespace-nowrap tw:transition-[color,box-shadow] tw:focus-visible:ring-[3px] tw:focus-visible:outline-1',
                'tw:disabled:pointer-events-none tw:disabled:opacity-50 tw:data-[state=active]:shadow-sm tw:[&_svg]:pointer-events-none',
                'tw:[&_svg]:shrink-0 tw:[&_svg:not([class*=size-])]:size-4',
                className,
            )}
            {...props}
        />
    )
}

function TabsContent({ className, ...props }) {
    return (
        <TabsPrimitive.Content
            data-slot="tabs-content"
            className={cn('tw:flex-1 tw:outline-none', className)}
            {...props}
        />
    )
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
